"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getScriptNode = void 0;
const getScriptNode = (src) => {
    const node = document.querySelector(`script[src="${src}"]`);
    const status = node?.getAttribute('data-status');
    return {
        node,
        status,
    };
};
exports.getScriptNode = getScriptNode;
